import { createAsyncThunk } from "@reduxjs/toolkit";

import { API } from "../../../api/services";

export const sendInquiry: any = createAsyncThunk(
  "channelDetails/sendInquiry",
  async (payload) => {
    const response = await API.post(`/send-inquiry`, payload);


      
    return response?.data;
  }
);
